<template>
  <div>
    <el-dialog 
      :visible.sync="aboutVisible"  
      class="about-part"
      :before-close="handleClose">
      <img class="taskman-logo" src="@/assets/images/common/TaskMan.png" alt="">
      <div class="version-info">
        <div>{{ $t('用户中心')}}：{{ versionInfo.version  }}</div>
        <div>{{ $t('运行环境')}}：{{ versionInfo.environment }}</div>
        <div>{{ $t('最近更新日期')}}：{{ versionInfo.updateDate }}</div>
      </div>
      <div class="company-info">
        <img src="@/assets/images/common/WeChat.png" alt="">
        <img src="@/assets/images/common/Tiktok.png" alt="">
        <div class="company-info-content">
          <div>{{ $t(`${companyInfo.name}`) }}</div>
          <div>{{$t('电话')}}：{{ companyInfo.phone }}</div>
          <div>{{$t('电子邮件')}}：{{ companyInfo.email }}</div>
          <div>{{$t('网址')}}：{{ companyInfo.website }}</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>

export default {

  props:{
    aboutVisible: {
       type: Boolean,
       default: false
     }
  },
  data(){
    return {
      versionInfo:{ //版本信息
        version:'V1.4',
        environment:'Windows',
        updateDate:'2025.02.15',
      },
      companyInfo:{ //公司信息
        name:'广州里工实业有限公司',
        phone:'86 20 3639 8816',
        email:'ligong@li-gong.com',
        website:'www.li-gong.com',
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:aboutVisible', false);
    }
  }
}
</script>
<style scoped lang="scss">
.about-part{
  ::v-deep .el-dialog{
    width: 727px;
    height: 447px;
    border-radius: 18px; 
    background: #262626;
    .el-dialog__body{
      padding: 36px 80px 45px 80px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
    }
    .el-dialog__close::before{
      font-size: 38px;
      color: #FFFFFF;
    }
    .taskman-logo{
      width: 295px;
    }
    .version-info{
      text-align: left;
      margin-top: 31px;
      font-size: 24px;
      line-height: 36px;
      color: #FFFFFF;
    }
    .company-info{
      margin-top: 30px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      img{
        width: 85px;
        height: 85px;
      }
      img:nth-child(1){
        margin-right: 20px;
      }
      img:nth-child(2){
        margin-right: 43px;
      }
      .company-info-content{
        text-align: left;
        font-size: 22px;
        color: #A9ADAF;
        line-height: 30px;
      }
    }
  }
}
</style>